import {OrderTableColumn} from './model/order-table-column';
import {OrderColumns} from './model/order.columns';

export class OrderTableUtils {

  public static tableCols: OrderTableColumn[] = [
    {idx: 0, name: 'orderNumber', type: 'string', size: 110, filtering: false},
    {idx: 10, name: 'client', type: 'client', size: 120, filtering: false},
    {idx: 20, name: 'clientOrderNumber', type: 'string', size: 110, filtering: false},
    {idx: 30, name: 'creator', type: 'employee', size: 120, filtering: false},
    {idx: 40, name: 'forwarder', type: 'employee', size: 90, filtering: false},
    {idx: 50, name: 'dispatcher', type: 'employee', size: 90, filtering: false},
    {idx: 60, name: 'department', type: 'department', size: 120, filtering: false},
    {idx: 70, name: 'status', type: 'status', size: 83, filtering: false},
    {idx: 80, name: 'freight', type: 'number', size: 60, filtering: false},
    {idx: 90, name: 'currency', type: 'currency', size: 70, filtering: false},
    {idx: 100, name: 'vehicle', type: 'vehicle', size: 120, filtering: false},
    {idx: 110, name: 'trailer', type: 'trailer', size: 90, filtering: false},
    {idx: 120, name: 'container', type: 'string', size: 80, filtering: false},
    {idx: 130, name: 'driverName', type: 'string', size: 100, filtering: false},
    {idx: 140, name: 'orderType', type: 'orderType', size: 90, filtering: false},
    {idx: 150, name: 'carrier', type: 'carrier', size: 100, filtering: false},
    {idx: 160, name: 'loadingAmount', type: 'number', size: 81, filtering: false},
    {idx: 170, name: 'loadingsCount', type: 'number', size: 70, filtering: false},
    {idx: 180, name: 'loadingDate', type: 'picker', size: 80, filtering: false},
    {idx: 190, name: 'loadingCountry', type: 'string', size: 80, filtering: false},
    {idx: 200, name: 'loadingPostalCode', type: 'string', size: 80, filtering: false},
    {idx: 210, name: 'loadingCity', type: 'string', size: 100, filtering: false},
    {idx: 220, name: 'unloadingAmount', type: 'number', size: 85, filtering: false},
    {idx: 230, name: 'unloadingsCount', type: 'number', size: 70, filtering: false},
    {idx: 240, name: 'unloadingDate', type: 'picker', size: 80, filtering: false},
    {idx: 250, name: 'unloadingCountry', type: 'string', size: 80, filtering: false},
    {idx: 260, name: 'unloadingPostalCode', type: 'string', size: 85, filtering: false},
    {idx: 270, name: 'unloadingCity', type: 'string', size: 100, filtering: false},
    {idx: 280, name: 'plannedDistance', type: 'number', size: 75, filtering: false},
    {idx: 290, name: 'paidDistance', type: 'number', size: 75, filtering: false},
    {idx: 300, name: 'emptyDistance', type: 'number', size: 80, filtering: false},
    {idx: 310, name: 'loadedDistance', type: 'number', size: 85, filtering: false},
    {idx: 311, name: 'actualDistance', type: 'number', size: 85, filtering: false},
    {idx: 320, name: 'totalWeight', type: 'number', size: 60, filtering: false},
    {idx: 330, name: 'profit', type: 'number', size: 60, filtering: false},
    {idx: 340, name: 'foc', type: 'boolean', size: 65, filtering: false},
    {idx: 350, name: 'logisOrder', type: 'boolean', size: 65, filtering: false},
    {idx: 360, name: 'logisUpdatedAt', type: 'picker', size: 85, filtering: false},
    {idx: 370, name: 'invoiceNumber', type: 'string', size: 80, filtering: false},
    {idx: 380, name: 'invoiceStatus', type: 'invoiceStatus', size: 70, filtering: false},
    {idx: 390, name: 'paymentTerm', type: 'datePicker', size: 68, filtering: false},
    {idx: 400, name: 'latestOrderUpdate', type: 'datePicker', size: 85, filtering: false},
    {idx: 410, name: 'docsReceivedByEmail', type: 'boolean', size: 70, filtering: false},
    {idx: 420, name: 'docsByPost', type: 'boolean', size: 85, filtering: false},
    {idx: 430, name: 'comments', type: 'string', size: 80, filtering: false},
    {idx: 440, name: 'actions', type: 'nothing', size: 150, filtering: false},
    {idx: 450, name: 'loadStarted', type: 'picker', size: 80, filtering: false},
    {idx: 460, name: 'loadEnded', type: 'picker', size: 85, filtering: false},
    {idx: 470, name: 'unloadStarted', type: 'picker', size: 85, filtering: false},
    {idx: 480, name: 'unloadEnded', type: 'picker', size: 80, filtering: false},
    {idx: 490, name: 'cleaningPlace', type: 'string', size: 115, filtering: false},
    {idx: 500, name: 'cleaningStarted', type: 'picker', size: 80, filtering: false},
    {idx: 510, name: 'cleaningEnded', type: 'picker', size: 80, filtering: false},
    {idx: 520, name: 'loadDelayed', type: 'number', size: 60, filtering: false},
    {idx: 530, name: 'unloadDelayed', type: 'number', size: 60, filtering: false},
    {idx: 540, name: 'vat', type: 'vat', size: 60, filtering: false},
  ];

  public static defaultTableCols: OrderColumns[] = [
    {name: 'orderNumber', size: 110, filtering: false},
    {name: 'client', size: 120, filtering: false},
    {name: 'clientOrderNumber', size: 110, filtering: false},
    {name: 'creator', size: 120, filtering: false},
    {name: 'department', size: 90, filtering: false},
    {name: 'status', size: 83, filtering: false},
    {name: 'freight', size: 60, filtering: false},
    {name: 'currency', size: 70, filtering: false},
    {name: 'vehicle', size: 120, filtering: false},
    {name: 'vat', size: 60, filtering: false},
    {name: 'foc', size: 65, filtering: false},
    {name: 'invoiceNumber', size: 80, filtering: false},
    {name: 'invoiceStatus', size: 70, filtering: false},
    {name: 'comments', size: 80, filtering: false},
    {name: 'actions', size: 150, filtering: false},
  ];
}

export enum OrderTypes {
  TRANSPORT = 'TRANSPORT',
  SPEDITION = 'SPEDITION',
}

export enum Vat {
  VAT_NULL = 'VAT_NULL',
  VAT_NP = 'VAT_NP',
  VAT_0 = 'VAT_0',
  VAT_15 = 'VAT_15',
  VAT_19 = 'VAT_19',
  VAT_21 = 'VAT_21',
  VAT_23 = 'VAT_23',
}
